import { Switch, Route } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router";
import {
  jhhDefaultFeatures,
  jhhCreateProfileFeatures,
} from "./Utils/ConstantStrings/jhhDefaultStrings";

import Loader from "./Components/Shared/Loader";

import myReportsIcon from "./Assets/Images/myReports.svg";
import myReportsSelectedIcon from "./Assets/Images/myReportsSelected.svg";
import _ from "lodash";
import ConsentComponentRestrictAccess from "./HealthPatri/UI/Components/ConsentComponentRestrictAccess";
const SearchActivity = React.lazy(
  () => import("./FitnessTracker/Pages/SearchActivity/SearchActivity")
);
const SetGoals = React.lazy(
  () => import("./FitnessTracker/Pages/SetGoals/SetGoals")
);
const Activity = React.lazy(
  () => import("./FitnessTracker/Pages/Activity/Activity")
);
const Header = React.lazy(() => import("./Components/Shared/Header"));
const PrivateRoute = React.lazy(() => import("./PrivateRoute"));
const LoginTemplate = React.lazy(
  () => import("./Components/Shared/LoginTemplate/")
);

const Authorise = React.lazy(
  () => import("./PlugAndPlay/Components/Authorise")
);
const HealthPatri = React.lazy(
  () => import("./HealthPatri/UI/Components/Dashboard/index")
);
const FitnessDashboard = React.lazy(
  () => import("./FitnessTracker/Pages/FitnessDashboard")
);
const DetailsTracker = React.lazy(
  () => import("./FitnessTracker/Pages/DetailsTracker/DetailsTracker")
);

const routes = [
  {
    header: "Health Patri",
    path: "/",
    component: <HealthPatri />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "sidebottom",
    hasSideNav: true,
    hasFooter: false,
    hasHeader: true,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "Fitness Tracker",
    path: "/fitness",
    component: <FitnessDashboard />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "sidebottom",
    hasSideNav: true,
    hasFooter: false,
    hasHeader: true,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "Activity",
    path: "/fitness/activity/:id",
    component: <Activity />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "nostyle",
    hasSideNav: true,
    hasFooter: true,
    hasHeader: false,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "Set Goals",
    path: "/fitness/setgoals",
    component: <SetGoals />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "nostyle",
    hasSideNav: true,
    hasFooter: true,
    hasHeader: false,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "Add Activity",
    path: "/fitness/searchactivity",
    component: <SearchActivity />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "nostyle",
    hasSideNav: true,
    hasFooter: true,
    hasHeader: false,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "Steps Tracked",
    path: "/fitness/detailstracker",
    component: <DetailsTracker />,
    protectedRoute: true,
    renderWithoutPrimaryProfile: false,
    type: "nostyle",
    hasSideNav: true,
    hasFooter: true,
    hasHeader: false,
    image: myReportsIcon,
    selectedImage: myReportsSelectedIcon,
  },
  {
    header: "",
    path: "/add-account",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path={"/add-account"}
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: true,
  },
  {
    header: "",
    path: "/add-family-account",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path={"/add-family-account"}
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: false,
  },
  {
    header: "",
    path: "/verify-pin",
    showProfileImage: true,
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path={"/verify-pin"}
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasHeader: true,
  },
  {
    header: "",
    path: "/verify-family-pin",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhCreateProfileFeatures}
        hasHeader={false}
        path={"/verify-family-pin"}
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasHeader: false,
  },
  {
    header: "",
    path: "/login",
    component: (
      <LoginTemplate jhhDefaultFeatures={jhhDefaultFeatures} path={"/login"} />
    ),
    protectedRoute: false,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: true,
  },
  {
    header: "",
    path: "/create-mpin",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path="/create-mpin"
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: true,
  },
  {
    header: "",
    path: "/forgot-mpin",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path="/forgot-mpin"
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: true,
  },
  {
    header: "",
    path: "/my-profile",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path="/my-profile"
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: false,
  },
  {
    header: "",
    path: "/add-profile",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhCreateProfileFeatures}
        hasHeader={false}
        path="/add-profile"
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasHeader: false,
  },
  {
    header: "",
    path: "/create-family-mpin",
    component: (
      <LoginTemplate
        jhhDefaultFeatures={jhhDefaultFeatures}
        path="/create-family-mpin"
      />
    ),
    protectedRoute: true,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: false,
  },
  {
    header: "",
    path: "/authorise",
    component: <Authorise />,
    protectedRoute: false,
    renderWithoutPrimaryProfile: true,
    type: "nostyle",
    hasSideNav: false,
    hasFooter: false,
    hasHeader: false,
  },
];

const Routes = () => {
  const [pageAccess, _] = useState(true);

  return (
    <>
      {!pageAccess ? (
        <ConsentComponentRestrictAccess
          modalIsOpen={!pageAccess}
          handleSetConsent={() => {}}
        />
      ) : (
        <Suspense fallback={<Loader />}>
          <Switch>
            {routes.map(
              ({
                path,
                component,
                protectedRoute,
                hasSideNav,
                hasHeader,
                hasFooter,
                renderWithoutPrimaryProfile,
              }) =>
                protectedRoute ? (
                  <PrivateRoute
                    exact
                    path={path}
                    key={typeof path === "string" ? path : path[0]}
                    renderWithoutPrimaryProfile={renderWithoutPrimaryProfile}
                  >
                    {/* {hasHeader && <Header routelist={routes} />} */}
                    {hasHeader && <Header />}
                    <div className={hasHeader ? "wrapper" : "no-wrapper"}>
                      {/* {hasSideNav && <SideNav routelist={routes} />} */}
                      <div
                        className={
                          hasHeader
                            ? "main-content-without-padding"
                            : "main-content"
                        }
                      >
                        <div
                          className={
                            hasSideNav ? "right-content" : "without-sidenav"
                          }
                        >
                          {component}
                        </div>
                        {/* {hasFooter && <Footer />} */}
                      </div>
                    </div>
                  </PrivateRoute>
                ) : (
                  <Route
                    exact
                    key={typeof path === "string" ? path : path[0]}
                    path={path}
                  >
                    {/* {hasHeader && <Header routelist={routes} />} */}
                    {hasHeader && <Header />}
                    <div className={hasHeader ? "wrapper" : "no-wrapper"}>
                      {/* {hasSideNav && <SideNav routelist={routes} />} */}
                      <div
                        className={
                          hasHeader
                            ? "main-content-without-padding"
                            : "main-content"
                        }
                      >
                        <div
                          className={
                            hasSideNav ? "right-content" : "without-sidenav"
                          }
                        >
                          {component}
                        </div>
                        {/* {hasFooter && <Footer />} */}
                      </div>
                    </div>
                  </Route>
                )
            )}
            <Route exact path="/">
              <HealthPatri />
            </Route>
            <Redirect to="/" />
          </Switch>
        </Suspense>
      )}
    </>
  );
};

export default Routes;
